module.exports = __webpack_public_path__ + "img/img_notice.b5cd11f6.svg";